import InApp from 'detect-inapp';
import { LOGIN_METHOD, ELECTRON_APP_TYPE } from '../constant';

export const isElectron = () =>
    (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') ||
    (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) ||
    (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0)

export const getElectronVersion = async () => {
    if (isElectron()) {
        if (window?.appInfo?.version) return window?.appInfo?.version ?? null;
        else if (typeof window?.electron?.remote?.app?.getVersion === 'function') return (await window?.electron?.remote?.app?.getVersion?.()) ?? null;
    }
    return null;
}

export const getElectronAppName = () => {
    let appName = null;
    if (isElectron()) {
        if (window?.appInfo?.name) appName = window?.appInfo?.name ?? null;
        else if (typeof window?.electron?.remote?.app?.getName === 'function') appName = window?.electron?.remote?.app?.getName?.() ?? null;
    }
    if (appName) {
        appName = appName.toLowerCase();
        if (appName?.includes('track')) appName = 'superTrack';
        else if (appName?.includes('chat')) appName = 'superChat';
        else if (appName?.includes('superworks')) appName = 'superWorks';
    } else appName = "superChat";
    return appName;
}

export const getElectronProductAccess = (planAccess, electronAppType = ELECTRON_APP_TYPE.AUTO) => {
    if (!isElectron()) return [];
    const access = [];
    let appType = getElectronAppName(electronAppType);

    if(appType === 'superWorks') {
        if (electronAppType == ELECTRON_APP_TYPE.SUPER_CHAT && planAccess?.chat?.default?.access) access.push('chat');
        else if (electronAppType == ELECTRON_APP_TYPE.SUPER_TRACK && planAccess?.track?.default?.access) access.push('track');
        else {
            if (planAccess?.chat?.default?.access) access.push('chat');
            if (planAccess?.track?.default?.access) access.push('track');
        }
    } else if(appType === 'superChat') access.push('chat');
    else if(appType === 'superTrack') access.push('track');
    return access;
}

// export const detectDevice = (isName = false) => {
//     const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera);
//     if (isElectron()) return isName ? 'DESKTOP' : LOGIN_METHOD.DESKTOP;
//     else if (('ontouchstart' in document.documentElement) || (inapp.isMobile && inapp.isInApp)) return isName ? 'MOBILE' : LOGIN_METHOD.MOBILE;
//     else return isName ? 'WEB' : LOGIN_METHOD.WEB;
// }

export const detectDevice = (isName = false) => {
    try {
        const key = isElectron() ? 'DESKTOP'
            : window?.ReactNativeWebView ? 'MOBILE'
            : 'WEB';
        return isName ? key : LOGIN_METHOD[key];
    } catch (e) {
        console.log(':: Detect device error ::', e);
        const key = isElectron() ? 'DESKTOP' : 'WEB';
        return isName ? key : LOGIN_METHOD[key];
    }
};

export const isMobileDevice = () => {
    return ('ontouchstart' in document.documentElement);
}

export const isIpadOS = () => {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}
export const isInApp = () => {
    const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera);
    const inIpadOs = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
    if (inIpadOs && navigator.userAgent.includes('Safari')) return false
    else if (inapp.isInApp || inIpadOs) return true
    else return inapp.isInApp
}

export const isMobileTablet = () => {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export const getMobileOperatingSystem = () => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

/** detect webcam */
export const isWebcamEnabled = () => {
    return new Promise(function (resolve, reject) {
        // Check for browser support
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            reject(new Error('Browser does not support mediaDevices API'));
        }

        // Enumerate devices
        navigator.mediaDevices.enumerateDevices()
            .then(function (devices) {
                // Check for video input devices
                const videoDevices = devices.filter(function (device) {
                    return device.kind === 'videoinput';
                });

                resolve(videoDevices.length > 0);
            })
            .catch(function (error) {
                reject(error);
            });
    });
}

/** Webcam permission */
export const isWebcamPermissionDenied = () => {
    return new Promise(function (resolve, reject) {
        navigator.mediaDevices.getUserMedia({ video: true })
            .then(function (stream) {
                // Webcam permission granted
                stream.getTracks().forEach(function (track) {
                    track.stop();
                });
                resolve(false);
            })
            .catch(function (error) {
                if (error.name === 'NotAllowedError') {
                    // Webcam permission denied
                    resolve(true);
                } else {
                    // Other errors
                    reject(error);
                }
            });
    });
}

export const hrefClick = (url, event) => {
    if (isElectron()) {
        const shell = window.electron.shell
        if (url && url.preventDefault) {
            event = url;
            if (event && event.preventDefault) event.preventDefault();
            if (shell) shell.openExternal(event.target.href);
        } else {
            event && event.preventDefault && event.preventDefault();
            if (shell) shell.openExternal(url);
        }
    } else {
        if (url && !url.preventDefault) {
            if (event && event.preventDefault) event.preventDefault();
            window.location.href = url;
        }
    }
};

export const windowOpen = (url, target) => {
    if (isElectron()) {
        const shell = window.electron.shell
        if (shell) shell.openExternal(url);
    } else window.open(url, target ? target : '');
};

// ===== migrated from pms/src/common/functions/common.jsx =====
export const isDevice = () => {
    let userAgent = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test(userAgent),
        ios = /iphone|ipod|ipad/.test(userAgent);

    if (ios) {
        if (safari) {
            return 'browser'
        } else if (!safari) {
            return 'webview'
        }
    } else {
        return 'other'
    }
}
